export function DictionaryItem(data) {
    const { id, name, order } = data;
    return {
        id: `${id}`,
        text: name,
        sort: order,
    };
}

export function DictionaryAnswerItem(data) {
    const { id, name, own_variant } = data;

    if (!name && !own_variant) return null;

    if (own_variant) {
        return {
            id: `${own_variant}`,
            text: `${own_variant}`,
            custom: true,
        };
    }

    return {
        id: `${id}`,
        text: name,
    };
}
